import styled from 'styled-components';

export const TopText = styled.div`
  color: ${({ theme }) => theme.palette.text.primary};
  font-size: 16px;
  line-height: 22px;
`;

export const BottomText = styled.div`
  color: ${({ theme }) => theme.palette.text.secondary};
  font-size: 14px;
  line-height: 19px;
`;

export const RightText = styled.div`
  color: ${({ theme }) => theme.palette.text.secondary};
  font-size: 16px;
  width: 25%;
  display: flex;
  align-items: center;
  justify-content: flex-end;
  box-sizing: border-box;
`;

export const TextContainer = styled.div`
  text-align: left;
  float: left;
  width: 75%;
`;

export const SummaryRowContainer = styled.div`
  width: 100%;
  display: inline-flex;
  padding: 6px;
  box-sizing: border-box;
`;
